export const PROGRESS_BAR_MIN = 0;
export const PROGRESS_BAR_MAX = 100;

export const toProgressValue = (value: number): number =>
  Number.isFinite(value)
    ? Math.min(Math.max(value, PROGRESS_BAR_MIN), PROGRESS_BAR_MAX)
    : PROGRESS_BAR_MIN;
